import type { ReportPhotoContentProps } from "./ReportPhotoContent";
import { ReportPhotoError } from "./ReportPhotoError";
import { ReportPhotoImage } from "./ReportPhotoImage";
import { ReportPhotoLoading } from "./ReportPhotoLoading";

interface ReportPhotoMediaProps extends ReportPhotoContentProps {
  alt: string;
}

export function ReportPhotoMedia(props: ReportPhotoMediaProps) {
  const { alt, failed, image, layout, onLoadError, onRetry, url } = props;
  if (failed) return <ReportPhotoError imageId={image.id} onRetry={onRetry} />;
  if (!url) return <ReportPhotoLoading />;
  return (
    <ReportPhotoImage
      alt={alt}
      imageId={image.id}
      layout={layout}
      onLoadError={onLoadError}
      url={url}
    />
  );
}
